let response = null,
  url = null;

export const setCachedUrl = (newUrl) => (url = newUrl);

export const getCachedUrl = () => url;

export const setCachedResponse = (newResponse) => (response = newResponse);

export const getCachedResponse = () => response;
